import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "@bitsentry-ce/i18n";

const BASE_TITLE = "BitSentry";

/**
 * Route prefix -> i18n key (reusing the Navbar labels) or plain fallback
 * text for routes that have no nav entry. First match wins, so keep more
 * specific prefixes above shorter ones.
 */
const ROUTE_TITLES: ReadonlyArray<{
  prefix: string;
  labelKey?: string;
  fallback?: string;
}> = [
  { prefix: "/diagnosis", labelKey: "navigation.navbar.diagnosis" },
  { prefix: "/incidents", labelKey: "navigation.navbar.incidents" },
  { prefix: "/runbooks", labelKey: "navigation.navbar.runbooks" },
  { prefix: "/results", labelKey: "navigation.navbar.results" },
  { prefix: "/investigations", labelKey: "navigation.navbar.results" },
  { prefix: "/tickets", labelKey: "navigation.navbar.ticketManagement" },
  {
    prefix: "/resolution",
    labelKey: "navigation.navbar.resolutionManagement",
  },
  { prefix: "/integrations", fallback: "Integrations" },
  { prefix: "/settings", labelKey: "navigation.navbar.adminSettings" },
  { prefix: "/profile", labelKey: "navigation.navbar.profile" },
  { prefix: "/login", fallback: "Sign in" },
  { prefix: "/forgot-password", fallback: "Reset password" },
  { prefix: "/reset-password", fallback: "Reset password" },
  { prefix: "/auth/reset-password", fallback: "Reset password" },
  { prefix: "/confirm-email", fallback: "Confirm email" },
  { prefix: "/magic-link", fallback: "Sign in" },
];

function PageTitleUpdater() {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    const entry = ROUTE_TITLES.find(
      ({ prefix }) =>
        location.pathname === prefix ||
        location.pathname.startsWith(`${prefix}/`),
    );

    let pageLabel: string | undefined;
    if (entry?.labelKey !== undefined) {
      pageLabel = t(entry.labelKey);
    } else if (entry?.fallback !== undefined) {
      pageLabel = entry.fallback;
    }

    if (pageLabel === undefined || pageLabel === "") {
      document.title = BASE_TITLE;
      return;
    }

    // Same naming format as the marketing site (apps/marketing Layout.astro).
    document.title = `${pageLabel} | ${BASE_TITLE}`;
  }, [location.pathname, t]);

  return null;
}

export default PageTitleUpdater;
